<template>
  <!-- <div class="check-exam-status" v-loading="loading"> -->
  <div class="check-exam-status">
    <div class="exam-header">
      <el-row type="flex" justify="space-between">
        <el-col :span="8" class="exam-title">
          <el-tooltip effect="light" :content="examInfo.manageName" placement="right">
            <h3>{{ examInfo.manageName }}</h3>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <div class="goback" v-if="!isDingding">
            <i class="iconfont icon-guanbi2" title="关闭" @click="closePage"></i>
            <span class="closeitem" @click="closePage">关闭</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="exam-main">
      <div class="result-wrapper">
        <div class="status-info">
          <div class="exam-user">
            <div class="exam-user-photo">
              <el-avatar
                v-if="examInfo.userId"
                :size="100"
                :src="'/oua2/getUserPhoto?type=relativePath&userId=' + examInfo.userId"
                @error="errorHandler"
              >
              </el-avatar>
            </div>
            <div class="exam-user-name">
              <span>{{ examInfo.userName }}</span>
            </div>
          </div>
          <el-tooltip class="item" effect="light" :content="examInfo.manageName" placement="top">
            <div class="exam-title">
              <p>{{ examInfo.manageName }}</p>
            </div>
          </el-tooltip>
          <div class="exam-dividing-line"></div>
          <div class="content">
            <div class="exam-scors-wrapperpass">
              <div v-if="examInfo.isPass === '0' || examInfo.isPass === '1'">
                考试成绩<span
                  class="exam-scors"
                  :class="{
                    'exam-scors-fail': examInfo.isPass === '0',
                    'exam-scors-pass': examInfo.isPass === '1',
                  }"
                >
                  {{ examInfo.showText }}</span
                >
              </div>
              <div v-else-if="examInfo.isPass === '不公布'">
                <span class="exam-scors"> {{ examInfo.showText }}</span>
              </div>
              <div v-else>
                <span>{{ "暂无成绩" }}</span>
              </div>
            </div>
          </div>

          <div class="table-content">
            <el-table max-height="350" ref="singleTable" :data="examInfo.presentScoreList" highlight-current-row style="width: 100%">
              <el-table-column label="次数" width="90">
                <template slot-scope="scope"> 第{{ scope.row.time }}次 </template>
              </el-table-column>
              <el-table-column label="成绩" width="90" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === '完成'">{{ scope.row.showText }}</span>
                  <span v-else>{{ scope.row.status }}</span>
                  <!-- <span>{{ scope.row.showText }}</span> -->
                </template>
              </el-table-column>
              <el-table-column property="examDatetimeEdate" label="交卷时间" width="200" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column width="140" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="continueExam(scope.$index, scope.row)"
                    v-if="scope.row.status === '进行中' && examing === true"
                    type="text"
                    size="small"
                    :disabled="isTeacher"
                  >
                    {{ isTeacher ? "" : "继续考试" }}
                  </el-button>
                  <el-button v-else @click.native.prevent="checkDetails(scope.$index, scope.row)" type="text" size="small"> 查看详情 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="exam-button-bar" v-if="!isTeacher">
          <div @click="tryAgain" class="exam-button-item" v-if="examInfo.status !== '历史' && examInfo.remainNum !== '0' && examing === false">
            <span v-if="examInfo.infinite === true">再考一次(不限次)</span>
            <span v-else-if="examInfo.infinite === false">再考一次({{ examInfo.remainNum }}次)</span>
          </div>

          <div @click="continueExam" class="exam-button-item" v-else-if="examing === true">继续考试</div>
          <div @click="closePage" class="exam-button-item" v-else-if="!isDingding">关闭</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dsfExamResult",
  data() {
    return {
      loading: false,
      isTeacher: false,
      examInfo: {
        userName: "",
        userPhoto: "",
        manageName: "",
        userphotourl: "",
      },
      isDingding: dsf.cookies.get("isDd"), // 网络学院内处理掉按钮
    };
  },
  computed: {
    examing() {
      if (this.examInfo.presentScoreList && this.examInfo.status !== "历史") {
        var isexaming = this.examInfo.presentScoreList.some((exam) => exam.status == "进行中");
      }
      return isexaming;
    },
  },
  created() {},
  mounted() {
    if (this.$route.query.type || this.$route.query.userId) {
      this.isTeacher = true;
    }
    this.getHistoryScore();
  },

  methods: {
    errorHandler() {
      return true;
    },

    //查看历史分数
    getHistoryScore() {
      this.loading = true;
      this.$http
        .get(
          "/record/getHistoryScore",
          {
            manageId: this.$route.query.manageId,
            batchId: this.$route.query.batchId,
            type: this.$route.query.type,
            userId: this.$route.query.userId,
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (res.success) {
            this.examInfo = {
              ...res.data,
            };
            this.loading = false;
          } else {
            this.loading = true;
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          //错误
          dsf.layer.message(err.message || "请求异常", false);
          this.loading = true;
        });
    },
    checkDetails(index, row) {
      this.$router.push("/pc/exam/exam-record?id=" + row.recordId + "&type=record");
      // 钉钉里跳转问题修改
      // let url = location.pathname + "#/pc/exam/exam-record?id=" + row.recordId + "&type=record";
      // location.replace(url);
    },

    closePage() {
      window.close();
      window.history.go(-1);
    },       

    tryAgain() {
      let url = location.pathname + "#/pc/exam/manage/examinfo?batchId=" + this.$route.query.batchId + "&share=0";
      location.replace(url);
      // window.open(url);
    },

    //继续考试
    continueExam(index, row) {
      var exam = this.examInfo.presentScoreList.filter((exam) => {
        return exam.status == "进行中";
      });
      if (row) {
        this.$router.push("/pc/exam/exam?recordId=" + row.recordId + "&type=manage");
      } else {
        if (exam && exam[0]) {
          this.$router.push("/pc/exam/exam?recordId=" + exam[0].recordId + "&type=manage");
        }
      }
    },
  },
};
</script>
